// Броячите за значките в менюто на „Складова база" (GET /inventory/nav-counts).
// Лек endpoint — само COUNT-и; до стария BE (404) менюто пада на броя на
// чакащите отчети (виж useSidebarBadges).
import { api } from "./client";

export interface InventoryNavCounts {
  pendingReports: number;
  // от тях — закъснелите (над OVERDUE_REPORT_DAYS); стар BE го няма
  overduePendingReports?: number;
  myDeliveryDraft: boolean;
  deliveryDrafts: number;
  unpaidDeliveries: number;
  // незавършените листове на другите операции (BE отпреди тях ги няма)
  writeoffDrafts?: number;
  transferDrafts?: number;
  stocktakeDrafts?: number;
}

export async function getInventoryNavCounts(): Promise<InventoryNavCounts> {
  const res = await api.get<InventoryNavCounts>("/inventory/nav-counts");
  return res.data;
}
